import { Button, Grid2 } from "@mui/material";
import Typography from "@mui/material/Typography";
import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import "./listStyles.scss";

const SettingsTemplateListItem = ({ id, name, instructionValue, handleEdit, handleDelete }) => {
    return (
        (<Grid2 className={classnames("settings-template-list-item")} container>
            <Grid2
                size={{
                    xs: 12,
                    md: 3
                }}>
                <p className="title">{name}</p>
            </Grid2>
            <Grid2
                size={{
                    xs: 12,
                    md: 7
                }}>
                <Typography
                    style={{ fontSize: "0.9rem" }}
                    dangerouslySetInnerHTML={{ __html: instructionValue ? instructionValue : "" }}
                />
            </Grid2>
            <Grid2
                className="actions"
                style={{ display: "flex", justifyContent: "flex-end" }}
                size={{
                    xs: 12,
                    md: 2
                }}>
                <div className="button-container">
                    <Button
                        variant={"outlined"}
                        size="small"
                        color={"secondary"}
                        style={{ height: 32 }}
                        onClick={() => handleEdit(id, name, instructionValue)}
                    >
                        Edit
                    </Button>
                    <Button variant={"outlined"} size="small" onClick={() => handleDelete(id)}>
                        Delete
                    </Button>
                </div>
            </Grid2>
        </Grid2>)
    );
};

SettingsTemplateListItem.propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    instructionValue: PropTypes.string.isRequired,
    handleEdit: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
};

export default SettingsTemplateListItem;
